import { applyMiddleware, createStore } from "redux";
import thunk from "redux-thunk";
import { reducers } from "./index";

const middleware =
  process.env.NODE_ENV !== "production"
    ? [require("redux-immutable-state-invariant").default(), thunk]
    : [thunk];

export const store = createStore(reducers, applyMiddleware(...middleware));
